import React, { useCallback, useEffect, useState } from 'react';

import { cn } from 'lib/helpers/utility';
import { usePracticeSupportSettings } from 'lib/hooks/queries/practice/usePracticeSupportSettings';
import { DEVICE_SIZES, useWindowSize } from 'lib/hooks/useWindowSize';

import Icon from 'components/shared/Icon/Icon';

import PhoneSupportModal from './PhoneSupportModal';

const AssistanceCard = ({ practiceId, isNarrowScreen, closeSidebar }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showPhoneSupport, setShowPhoneSupport] = useState(false);
  const { device } = useWindowSize();

  const { data: supportData } = usePracticeSupportSettings({
    params: { practiceId },
    dependencies: [practiceId],
    options: { enabled: !!practiceId }
  });

  // Listen to Intercom events to keep state in sync
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.Intercom !== 'function') {
      return;
    }

    // Register callbacks for Intercom show/hide events
    window.Intercom('onShow', () => setIsOpen(true));
    window.Intercom('onHide', () => setIsOpen(false));
  }, []);

  const toggleIntercom = useCallback(() => {
    // Check if Intercom is available before trying to use it
    if (typeof window === 'undefined' || typeof window.Intercom !== 'function') {
      console.warn('Intercom is not initialized');
      return;
    }

    if (isOpen) {
      window.Intercom('hide');
    } else {
      window.Intercom('show');
      if (isNarrowScreen) {
        closeSidebar();
      }
    }
  }, [isOpen]);

  return (
    <div
      className={cn(
        'assistance-card flex items-center justify-between rounded-xl bg-white px-4 py-1.5',
        device === DEVICE_SIZES.MOBILE && 'rounded-none'
      )}>
      <p className="text-xs">Get assistance whenever you need it.</p>
      <div className="flex gap-2">
        <div className="flex h-7 w-7 items-center justify-center">
          <Icon
            size={20}
            icon="call-calling-mono"
            color="primary"
            className="cursor-pointer"
            onClick={() => {
              setShowPhoneSupport((prev) => !prev);
              if (isNarrowScreen) {
                closeSidebar();
              }
            }}
          />
        </div>
        <div className="flex h-7 w-7 items-center justify-center">
          <Icon
            size={20}
            icon="intercom-mono"
            className="cursor-pointer"
            onClick={toggleIntercom}
            data-intercom-trigger="true"
          />
        </div>
      </div>
      <PhoneSupportModal
        isOpen={showPhoneSupport}
        onClose={() => setShowPhoneSupport(false)}
        supportData={supportData}
      />
    </div>
  );
};

export default AssistanceCard;
